import React, { createContext, useEffect } from "react";
import { useCartContextQuery } from "@common-vendors/generated/graphql";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var cartInitialState = {
  orderSummary: {
    itemSummary: {
      items: []
    },
    totalPrice: {
      amount: 0
    }
  }
};
export var CartContext = /*#__PURE__*/createContext({
  data: cartInitialState,
  loading: false
});
export var CartContextProvider = function CartContextProvider(_ref) {
  var children = _ref.children;

  var _useCartContextQuery = useCartContextQuery(),
      data = _useCartContextQuery.data,
      loading = _useCartContextQuery.loading,
      refetch = _useCartContextQuery.refetch;

  var cartData = !(data !== null && data !== void 0 && data.cart) ? cartInitialState : data.cart;
  useEffect(function () {
    var mounted = true;

    if (mounted) {
      refetch();
    }

    return function () {
      mounted = false;
    };
  }, [refetch]);
  return ___EmotionJSX(CartContext.Provider, {
    value: {
      data: cartData,
      loading: loading
    }
  }, children);
};